'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType from "./presto.types$-Two-Factor-Auth-Type.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthType$$anon$151(_$ordinal$35, \u03b4name$35, outer) {
  this.cyf = 0;
  this.a9R = null;
  this.cyf = _$ordinal$35;
  this.a9R = \u03b4name$35;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$TwoFactorAuthType$$anon$151 as $c_Lpresto_types$TwoFactorAuthType$$anon$151 };
$p = $c_Lpresto_types$TwoFactorAuthType$$anon$151.prototype = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType.$h_Lpresto_types$TwoFactorAuthType();
$p.constructor = $c_Lpresto_types$TwoFactorAuthType$$anon$151;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthType$$anon$151() {
}
export { $h_Lpresto_types$TwoFactorAuthType$$anon$151 as $h_Lpresto_types$TwoFactorAuthType$$anon$151 };
$h_Lpresto_types$TwoFactorAuthType$$anon$151.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9R;
});
$p.l = (function() {
  return this.a9R;
});
var $d_Lpresto_types$TwoFactorAuthType$$anon$151 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthType$$anon$151, "presto.types$TwoFactorAuthType$$anon$151", ({
  a2r: 1,
  a2p: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$TwoFactorAuthType$$anon$151 as $d_Lpresto_types$TwoFactorAuthType$$anon$151 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Type$$anon$151.js.map
